/**
 * Product Quantity Element:  x-quantity
 *
 */

class ProductQuantityElement extends HTMLElement {
  static QUANTITY_SELECTOR = '[data-role="quantity"]'
  static INCREASE_SELECTOR = '[data-role="increase"]'
  static DECREASE_SELECTOR = '[data-role="decrease"]'
  static QUANTITY_INPUT_SELECTOR = '[data-role="input_quantity"]'
  constructor() {
    super()
    this.actionKeys = {
      INCREASE: 'increase',
      DECREASE: 'decrease'
    }
    this.limit = this.dataset.limit || 99
  }

  quantityActions(key, amount) {
    if (!key || !amount) {
      throw new Error('key or amount missing.')
    }
    return {
      [this.actionKeys.INCREASE]: amount + 1,
      [this.actionKeys.DECREASE]: amount - 1
    }[key]
  }

  fetchChildren() {
    this.quantity = this.querySelector(ProductQuantityElement.QUANTITY_SELECTOR)
    this.quantityInput = this.querySelector(ProductQuantityElement.QUANTITY_INPUT_SELECTOR)
    this.increaseButton = this.querySelector(ProductQuantityElement.INCREASE_SELECTOR)
    this.decreaseButton = this.querySelector(ProductQuantityElement.DECREASE_SELECTOR)
  }

  checkLimit(value) {
    if (value >= this.limit) {
      return this.limit
    }
    if (value <= 0) {
      return 1
    }
    return value
  }

  handleOnClickCallBack(e) {
    const { dataset } = e.currentTarget
    const { role } = dataset
    const quantity = this.getCurrentQuantity()
    const newQuantity = this.checkLimit(this.quantityActions(role, quantity))
    this.setCurrentQuantity(newQuantity)
  }

  getCurrentQuantity() {
    return parseInt(this.quantity.innerText)
  }

  setCurrentQuantity(value) {
    this.quantity.innerText = value.toString()
    this.quantityInput.value = value
  }

  addEventListeners() {
    this.increaseButton.addEventListener('click', this.handleOnClickCallBack.bind(this))
    this.decreaseButton.addEventListener('click', this.handleOnClickCallBack.bind(this))
  }

  removeEventListeners() {
    this.increaseButton.removeEventListener('click', this.handleOnClickCallBack.bind(this))
    this.decreaseButton.removeEventListener('click', this.handleOnClickCallBack.bind(this))
  }

  connectedCallback() {
    this.fetchChildren()
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }
}

customElements.define('x-quantity', ProductQuantityElement)
